import React from 'react';
import Cookies from 'js-cookie';
import Sorting from './Sorting';
import _ from 'lodash';
import '../css/Music.css';
// import SearchBar from 'material-ui-search-bar';
import Loader from 'react-loader-spinner'
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
;


// component used in ai section for viewing ai data

class Music extends React.Component{
  state={
    logData: [],
    sortedType: '',
    actualData: [],
    searchValue: '',
    searchActive: false,
    loadSpinner: true,
  }
  componentDidMount(){
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
  }
  fetch('/cloud/aimusicdata' ,{
    method: "GET",
    headers: headers,
})
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {
  this.setState({
    logData: data,
    actualData: data
  },()=>{
    this.setState({
      loadSpinner: false
    })
    console.log(this.state.logData)})
})
.catch((err)=>{
  console.log(err)
})
  }

  restoreData = (data) => {
    this.setState({
      logData: data
    })
 }
   sortingFunc = (type,searchValue) => {
     if(this.state.sortedType!==type && type!=='search' ){
       this.setState({
         sortedType: type
       })
     Sorting(this.restoreData, type, this.state.logData);
     }else if(type==='search'){
       type='search';
       Sorting(this.restoreData, type, this.state.actualData,searchValue);
     }else{
       type='reverse';
     Sorting(this.restoreData, type, this.state.logData);
     }
   }

   handleClickOpen = scroll => () => {
    this.setState({ open: true, scroll });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
 

    render(){
        return (
          <div className="music">
             { this.props.redux.auth.searchBarShow ?  <div className='animated animated-duration-custom slideInDown pb-3 mx-4'>
                        <IntegrationReactSelectNew  autoFocus
                                    value={this.state.searchValue}
                                    onChange={(e)=>{                  
                                      this.setState({
                                        searchValue: e
                                      },()=>{
                                        this.sortingFunc('search',this.state.searchValue)
                                      })
                                    }
                                  }  
                                  onRequestSearch={() => this.sortingFunc('search',this.state.searchValue)}
                                  /></div> : null}
             <h3 className="ai-heading dashboard-ai-heading ml-5">AI Music User Data</h3>
        {!this.state.loadSpinner ?   <div className="si-list ">
        <div className="outer">
        <div className="flex">      
              <table className="table table-striped table-fixed">
                <thead className="tableHeaderColor">                 
                    <th scope="col">S.No <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('ID')}}></i></th>
                    <th scope="col">User ID  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('userId')}}></i></th>
                    <th scope="col">Genre  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('genre')}}></i></th>
                    <th scope="col">Tracks  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('track')}}></i></th>
                    <th scope="col">In Time  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('in_time')}}></i></th>
                    <th scope="col">Out Time  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('out_time')}}></i></th>
                    <th scope="col">Duration  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('duration')}}></i></th>
                    <th scope="col">Date  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('date')}}></i></th>
                    <th scope="col">Artist  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('artist')}}></i></th>
                    <th scope="col">Album  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('album')}}></i></th>
                    <th scope="col">Room ID  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('roomId')}}></i></th>
                    <th scope="col">Room Type  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('roomtype')}}></i></th>
                    <th scope="col">Spotify  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('spotifyRating')}}></i></th>                
                </thead>             
                <tbody className="bodyWidth">         
                  {this.state.logData.map((e,index)=>{
                    return (
                      <tr key={index} className="some-hover">
                        <th scope="row">{e.ID}</th>
                        <td>{e.userId}</td>
                        <td>{e.genre}</td>
                        <td>{e.track}</td>
                        <td>{e.in_time}</td>
                        <td>{e.out_time}</td>
                        <td>{e.duration}</td>
                        <td>{e.date}</td>
                        <td>{e.artist}</td>
                        <td>{e.album}</td>
                        <td>{e.roomId}</td>
                        <td>{e.roomtype}</td>
                        <td>{e.spotifyRating}</td>
                      </tr>
                    )
                  })}
                </tbody>                
              </table>
        </div>
        </div>
        </div> :    <div className="spinnerLoad" style={{'marginTop': '12%', 'marginLeft': '45%'}}>
          <Loader 
	     type="Bars"
	     color="#f89500"
	     height="75"	
	     width="75"
       />    
          </div>}
        </div>
        );
      }
    }
    const mapStateToProps = state  => {
      return {
        redux: state,
      };
    };
    
    
    
    const mapDispatchToProps = dispatch => {
      return {
        searchBarActivate: (data) => dispatch({type: ActionTypes.SEARCHBAR, data: data }),
      };
    };
    
    
    export default connect(mapStateToProps, mapDispatchToProps) (Music);